import {
  Box,
  Card,
  CardActions,
  CardContent,
  Skeleton,
  Typography
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getCommentsByScamId, fetchAllScamsAlertsWithReactionsApi } from "src/api_endpoints/userDashboard/ScamAPI";
import PostScam from "src/components/scam_section/PostScam";
import ScamAlertCommonCard from "src/components/scam_section/ScamAlertCommonCard";
import ViewCommentsModal from "src/components/scam_section/ViewCommentsModal";
import ViewScamImagesModal from "src/components/scam_section/viewScamImagesModal";
import Footer from "../components/front-end/footer";
import FrontHeader from "../components/front-end/Header";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";

const PrepostScam = () => {
  const navigate = useNavigate()
  const [posts, setPosts] = useState([]);
  const [currentImages, setCurrentImages] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openCommentsModal, setOpenCommentsModal] = useState(false);
  const [isPreScam, setIsPreScam] = useState(true);
  const [currentScamComments, setCurrentScamComments] = useState([]);
  const { isLoggedIn } = useSelector((state) => state.userState);

  const handleOpenModal = (images) => {
    setCurrentImages(images);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleOpenCommentsModal = async (scm) => {
    try {
      const scam_id = scm?.scamPK;

      if (!scam_id) {
        throw new Error("Invalid scam ID provided");
      }

      const res = await getCommentsByScamId({ scam_id });
      if (res) {
        setCurrentScamComments(res.comments);
        setOpenCommentsModal(true);
      } else {
        throw new Error("Failed to fetch comments or no comments found.");
      }
    } catch (error) {
      console.error("Error fetching comments:", error.message);
    }
  };

  const handleCloseCommentsModal = () => {
    setOpenCommentsModal(false);
  };
  const handleReaction = () => {
    navigate('/login')
  }
  const fetchPosts = useCallback(async () => {
    try {
      const res = await fetchAllScamsAlertsWithReactionsApi();
      if (res?.scams) {
        setPosts(res.scams);
      } else {
        console.error("No scam alerts found.");
      }
    } catch (error) {
      console.error("Error fetching scam alerts:", error);
    }
  }, []);

  useEffect(() => {
    fetchPosts();
  }, [fetchPosts]);
  return (
    <>
      <Helmet>
        <title>Report a Scam | Protect Freelancers</title>
        <meta name="description" content="Report scam clients or freelancers to alert the community and keep freelancing safe." />
      </Helmet>
      <Box
        sx={{
          backgroundColor: "#fff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
      >

        {" "}
        <FrontHeader />
        {/* Description Text */}
        <Box sx={{
          backgroundColor: '#f9f9f9',
          padding: '2rem',
          borderRadius: '8px',
          // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          textAlign: { xs: 'left', md: 'center' },
          color: '#333',
          fontSize: '1rem',
          margin: '2rem 2rem 0 2rem'
        }}>
          <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>
            Found yourself scammed on a Freelancing Job?
          </Typography>
          <Typography sx={{
            lineHeight: '1.6',
            color: '#555',
            marginBottom: '1.2rem'
          }}>
            If you’ve encountered a fraudulent client or freelancer, don’t stay silent.
            Alert the community by reporting the scam here. By sharing your experience,
            you help protect others and prevent the scammer from harming anyone else in the future.
          </Typography>
          <Typography sx={{
            fontWeight: 'bold',
            color: '#6d4cb1'
          }}>
            Let’s work together to keep our freelancing space safe and trustworthy for everyone.
          </Typography>
        </Box>

        <Box sx={{
          width: '55%',
          margin: '3rem auto',
          '@media (max-width: 900px)': {  // For md and below (tablet and mobile)
            width: '90%',
          }
        }}>

          <PostScam isPrepostScam={true} />
          <Box className='mt-5'>
            {posts?.length === 0 ? (
              [...Array(1)].map((_, index) => (
                <Card key={index} sx={{ backgroundColor: "#ffffff", borderRadius: 2, marginBottom: '1rem' }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Skeleton variant="text" width="50%" />
                      <Skeleton variant="text" width="30%" />
                    </Box>
                    <Skeleton variant="text" width="40%" />
                    <Skeleton variant="text" width="80%" sx={{ marginBottom: 2 }} />
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Skeleton variant="circular" width={40} height={40} />
                        <Skeleton variant="text" width="60%" />
                      </Box>
                      <Skeleton variant="rectangular" width={24} height={24} />
                    </Box>
                  </CardContent>
                  <Box sx={{ textAlign: 'center' }}>
                    <Skeleton variant="rectangular" width={120} height={30} sx={{ margin: 1 }} />
                    <Skeleton variant="rectangular" width={120} height={30} sx={{ margin: 1 }} />
                  </Box>
                  <CardActions sx={{ display: "flex", justifyContent: "space-between", padding: '.5rem 1rem' }}>
                    <Skeleton variant="rectangular" width={80} height={30} />
                    <Skeleton variant="rectangular" width={80} height={30} />
                  </CardActions>
                </Card>
              ))
            ) : (
              posts.map((scam, index) => (
                <ScamAlertCommonCard
                  key={index}
                  scam={scam}
                  onOpenModal={handleOpenModal}
                  onCloseModal={handleCloseModal}
                  openModal={openModal}
                  isViewMyReports={false}
                  handleOpenCommentsModal={handleOpenCommentsModal}
                  onReaction={handleReaction}
                  isLoggedIn={isLoggedIn}
                />
              ))
            )}
          </Box>
          {/* <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Link
            to="/client-expert/orders"
            sx={{
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
            className="explore-more-link"
          >
            Explore More...
          </Link>
        </Box> */}
        </Box>
        {/* Modal for Viewing Images */}
        <ViewScamImagesModal
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          currentImages={currentImages}
        />
        <ViewCommentsModal
          commentData={currentScamComments}  // Pass current comments
          open={openCommentsModal}
          handleClose={handleCloseCommentsModal}
          handleCreateComment={handleReaction}
          isPreScam={isPreScam}
        />
        <Footer />
      </Box>
    </>
  );
};

export default PrepostScam;
